import React, { FC } from "react";
import st from "./index.module.scss";
import { BenefitsTile } from "./BenefitsTile";

export const FocusPageBenefits: FC = () => {
  return (
    <div className={st.container}>
      <div className={st.heading}>
        Boss Your Day.
        <br />
        Sustained* Energy & Focus,
        <br />
        Now Available Everywhere.
      </div>
      <div className={st.tilesContainer}>
        <BenefitsTile
          backgroundColor="#CF80B8"
          imageUrl="https://www.datocms-assets.com/74813/1703683914-lions-mane_black.png"
          heading="Lions Mane"
          subheading="POPULAR MUSHROOM MEETS OG ENERGY"
        />
        <BenefitsTile
          backgroundColor="#FBC698"
          imageUrl="https://www.datocms-assets.com/74813/1703684281-no-crash_black.png"
          heading="Zero sugar"
          subheading="ALL FLAVOR, NO GUILT"
        />
        <BenefitsTile
          backgroundColor="#AFCE2D"
          imageUrl="https://www.datocms-assets.com/74813/1703684306-image50-106-copy.png"
          heading="200MG Caffeine"
          subheading="YOUR ENERGY & MENTAL BOOST COMPANION SO YOU CAN BE IN THE MOMENT"
        />
      </div>
    </div>
  );
};
